import { LABELS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/labels_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';
import { LabelEntityType } from '../types/labels';

const targetCollectionNames = [LabelEntityType.PART, 'partsIndex', 'partLabelsDropdown'];

const initialState: any = standardInitialStateGenerator(targetCollectionNames);

export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
